import {Component, EventEmitter, forwardRef, Injector, Input, Output} from "@angular/core";
import {ColumnComponent} from "../../../entity/grid/column.component";
import {AbstractColumnComponent} from "../../../entity/grid/abstract-column.component";
import {FormGroup} from "@angular/forms";
import {Image, ImageService} from "@fedeltapointofsale/data-client";

@Component({
    selector: "wbo-image-column",
    templateUrl: "./image-column.component.html",
    styleUrls: ["./image-column.component.scss"],
    providers: [
        {provide: ColumnComponent, useExisting: forwardRef(() => ImageColumnComponent), multi: true}
    ]
})
export class ImageColumnComponent extends AbstractColumnComponent {
    @Input() component: string;
    @Input() imageOpacityField: string;
    @Input() maxImageSize: number = 256000;
    @Input() allowSvg: boolean = false;
    @Input() showOpacitySlider: boolean = false;
    @Input() placeholderImageField: string;
    @Input() placeholderImageComponent: string;

    @Output() imageOpacityChange: EventEmitter<{ value: any, dataItem: any, formGroup: FormGroup}> = new EventEmitter();

    public imageService: ImageService;

    constructor(injector: Injector) {
        super(injector);
        this.imageService = injector.get(ImageService, null);
    }

    canLazyLoadImage(image: Image) {
        return image.id && image.image !== null;
    }

    override editingFields(): string[] {
        return [this.field, this.imageOpacityField];
    }

    controlImageOpacityChange(opacity: number, dataItem: any, formGroup: FormGroup): void {
        if (this.imageOpacityField) {
            formGroup.get(this.imageOpacityField).setValue(opacity);
            this.imageOpacityChange.emit({value: opacity, dataItem: dataItem, formGroup: formGroup});
        }
    }
}
